import React, { useState } from "react";
import { TextField } from "@mui/material";
import { useTranslateByGender } from "fe-common/locale/useTranslateByGender";
import useSessionStore from "../../context/useSessionStore";
import { InvalidQuestionMessage } from "./InvalidSummaryMessage";
import DefaultButton from "./DefaultButton";
import { MIX_PANEL_EVENTS } from "../../analytics/eventReporter";
import { SessionActionStatus } from "../../context/sessionStore";
import { navigateWithLocale } from "../../utils";
import { useNavigate } from "react-router-dom";
import { useEventReportedContext } from "../../analytics/EventReporterContext";

//region [[ Styles ]]

//endregion [[ Styles ]]

//region [[ Props ]]

export interface GeneralQuestionProps {}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const GeneralQuestion = ({ ...props }: GeneralQuestionProps) => {
  const [text, setText] = useState<string>("");
  const [invalid, setInvalid] = useState<boolean>(false);
  const { translate, locale } = useTranslateByGender();
  const { loadingChatSession, addSession, addQuestion, changeSessionName } =
    useSessionStore();
  const navigate = useNavigate();
  const reporter = useEventReportedContext();

  const handleAddGeneralSession = async () => {
    const newSession = await addSession("");
    reporter?.reportEvent(MIX_PANEL_EVENTS.ASKED_GENERAL_QUESTION, {
      failed: newSession.status !== SessionActionStatus.success,
    });
    setInvalid(newSession.status === SessionActionStatus.invalid);

    if (newSession.status === SessionActionStatus.success) {
      addQuestion(text, (answer) => {
        if (answer && answer.valid) {
          navigate(navigateWithLocale("../" + newSession.sessionId, locale));
          reporter?.reportAnswer(answer);
          changeSessionName(newSession.sessionId, answer.title);
        } else setInvalid(true);
      });
    }
  };

  return (
    <>
      <TextField
        fullWidth
        id={"patientSummary"}
        value={text}
        placeholder={translate("DIALOGUES_ASK_GENERAL_PLACEHOLDER")}
        onChange={(e) => setText(e.target.value)}
        disabled={loadingChatSession}
        multiline
        minRows={1}
      />
      <DefaultButton
        onClick={handleAddGeneralSession}
        disabled={text.length < 20 || loadingChatSession}
        className={`done-button`}
      >
        {translate("DONE")}
      </DefaultButton>
      {invalid && <InvalidQuestionMessage />}
    </>
  );
};
